import React from "react";

import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import FormControl from "@mui/material/FormControl";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import TextField from "@mui/material/TextField";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useDispatch, useSelector } from "react-redux";

import { setDateFilter } from "@/features/dataTableSlice";
import moment from "moment";
export function DateSelection(props) {
  const dispatch = useDispatch();

  const [dateFilterMode, setDateFilterMode] = React.useState(1);
  const [openDateFilter, setOpenDateFilter] = React.useState(false);
  const filterAnchorRef = React.useRef(null);
  const dataPickerStartRef1 = React.useRef(null);
  const dataPickerEndRef1 = React.useRef(null);
  const dateFilter = useSelector((state) => state.dataTable.dateFilter);

  const handleCloseDateFilter = (event) => {
    if (
      filterAnchorRef.current &&
      filterAnchorRef.current.contains(event.target)
    ) {
      return;
    }
    setOpenDateFilter(false);
  };
  return (
    <FormControl sx={{ m: 2 }}>
      <ButtonGroup
        variant="contained"
        aria-label="Basic button group"
        ref={filterAnchorRef}
      >
        <Button
          onClick={() => {
            setDateFilterMode(1);
            setOpenDateFilter(true);
            //dataPickerStartRef1.current?.parentElement.click();
          }}
        >
          {dateFilter.startDate1 && dateFilter.endDate1
            ? `${moment(dateFilter.startDate1).format("YYYY-MM-DD")} - ${moment(
                dateFilter.endDate1
              ).format("YYYY-MM-DD")}`
            : "選擇日期"}
        </Button>
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
          width: 250,
          mt: "10px!important",
        }}
        open={openDateFilter}
        anchorEl={filterAnchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleCloseDateFilter}>
                <div>
                  {dateFilterMode === 1 && (
                    <div>
                      <DatePicker
                        views={["year", "month", "day"]}
                        disableFuture
                        components={{
                          OpenPickerIcon: () => (
                            <CalendarMonthIcon ref={dataPickerStartRef1} />
                          ),
                        }}
                        label="Start Date"
                        onClose={() => {
                          dataPickerEndRef1.current.parentElement.click();
                        }}
                        value={dateFilter.startDate1}
                        onChange={(newValue) => {
                          dispatch(
                            setDateFilter({
                              field: "startDate1",
                              value: moment(newValue).format("YYYY-MM-DD"),
                            })
                          );
                          if (dateFilter.endDate1 === null) {
                            if (
                              moment(newValue).endOf("month").isAfter(moment())
                            ) {
                              dispatch(
                                setDateFilter({
                                  field: "endDate1",
                                  value: moment().format("YYYY-MM-DD"),
                                })
                              );
                            } else {
                              dispatch(
                                setDateFilter({
                                  field: "endDate1",
                                  value: moment(newValue)
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                })
                              );
                            }
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} sx={{ width: "100%" }} />
                        )}
                      />

                      <DatePicker
                        views={["year", "month", "day"]}
                        disableFuture
                        value={dateFilter.endDate1}
                        minDate={moment(dateFilter.startDate1)}
                        label="End Date"
                        components={{
                          OpenPickerIcon: () => (
                            <CalendarMonthIcon ref={dataPickerEndRef1} />
                          ),
                        }}
                        onChange={(newValue) => {
                          dispatch(
                            setDateFilter({
                              field: "endDate1",
                              value: moment(newValue).format("YYYY-MM-DD"),
                            })
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ width: "100%", mt: "10px!important" }}
                          />
                        )}
                      />
                    </div>
                  )}
                </div>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </FormControl>
  );
}
